module.exports = __webpack_public_path__ + "img/9788937434679.f51e7874.jpg";